import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class SeoService {
  private endpoint: string = environment.apiUrl;
  private pageCodeSubject = new BehaviorSubject<string>(localStorage.getItem("pageCode") || "home");
  pageCode$ = this.pageCodeSubject.asObservable();

  constructor(private http: HttpClient){}

  seoparameter(data: any): Observable<any> {
    const url = `${this.endpoint}seo`;
    return this.http.post<any>(url, data);
  }

  setPageCode(pageCode: string): void {
    localStorage.setItem("pageCode", pageCode);
    this.pageCodeSubject.next(pageCode);
  }

  getPageCode(): string {
    return localStorage.getItem("pageCode") || "home";
  }
}
